import Swiper from 'swiper/bundle'; 

export function initEventsSwipers(scope = document) {
  scope.querySelectorAll('[data-events-root]').forEach((root) => {
    root.querySelectorAll('.js-events-swiper').forEach((el) => {
      if (el._swiper && typeof el._swiper.destroy === 'function') {
        el._swiper.destroy(true, true);
        el._swiper = null;
      }

      let data = {};
      try { data = JSON.parse(el.getAttribute('data-options') || '{}'); } catch (_) {}

      const next = el.closest('.position-relative')?.querySelector('.events-next');
      const prev = el.closest('.position-relative')?.querySelector('.events-prev');
      const paginationEl = el.closest('.position-relative')?.querySelector('.events-pagination');

      const isMobileSwiper = el.closest('.d-md-none') !== null;

      el._swiper = new Swiper(el, {
        loop: !!data.loop,
        speed: 500,
        autoplay: data.autoplay
          ? { delay: Number(data.delay || 3500), disableOnInteraction: false, pauseOnMouseEnter: true }
          : false,

        slidesPerView: isMobileSwiper ? 1 : 3,
        spaceBetween: isMobileSwiper ? 16 : 24,

        navigation: (next && prev) ? { nextEl: next, prevEl: prev } : undefined,
        pagination: paginationEl ? { el: paginationEl, clickable: true } : undefined
      });
    });
  });
}
